export let OrgRelationshipModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        parentid: "section-1719383677777-form",
        elementid: "1719383687656",
        elementtype: "textfield",
      },
      {
        parentid: "section-1719383677777-form",
        elementid: "1719383715621",
        elementtype: "textarea",
      },
      {
        parentid: "section-1719383677777-form",
        elementid: "1719383722105",
        elementtype: "customSelect",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1719383677777",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
